// import "./TennisCourt.css";

import volleyballData from "../../data/volleyballData";

import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const VolleyballCourt = () => {
  return (
    <>
      <ServiceHero data={volleyballData} />

      <ServiceOverview data={volleyballData} />

      <ServiceBenefits data={volleyballData} />

      <ConstructionProcess />

      <TechnicalSpecs data={volleyballData} />

      <ServiceGallery data={volleyballData} />

      <WhyChooseService data={volleyballData} />

      <ServiceFAQ faqs={volleyballData.faqs} />

      <RelatedServices data={volleyballData} />

      <ServiceCTA data={volleyballData} />
    </>
  );
};

export default VolleyballCourt;
